import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getCustomDesigns = async () => {
  const response = await axios.get(`${base_url}custom-design/all`, getAuthHeaders());
  return response.data;
};

const deleteCustomDesign = async (id) => {
  const response = await axios.delete(`${base_url}custom-design/${id}`, getAuthHeaders());
  return response.data;
};

const getCustomDesign = async (id) => {
  const response = await axios.get(`${base_url}custom-design/get/${id}`, getAuthHeaders());
  return response.data;
};

const updateCustomDesign = async (design) => {
  const response = await axios.put(
    `${base_url}custom-design/edit/${design.id}`,
    { status: design.designData },
    getAuthHeaders()
  );
  return response.data;
};

const customDesignService = {
  getCustomDesigns,
  deleteCustomDesign,
  getCustomDesign,
  updateCustomDesign,
};

export default customDesignService;
